class LocalStorage {
    private readonly PREFIX: string = "loki.";

    getItem(name: string): string {
        let ret = localStorage.getItem(this.PREFIX + name);
        return ret === null ? "" : ret;
    }

    setItem(name: string, value: string): void {
        localStorage.setItem(this.PREFIX + name, value);
    }

    removeItem(name: string): void {
        localStorage.removeItem(this.PREFIX + name);
    }
}

export default new LocalStorage();
